import {AfricaDifficultyLevel} from "./types";

import {GAME_AFRICA} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as AfricaMap} from "../res/africa.svg";
import {Component} from "react";
import {Country, AFRICA_COUNTRIES} from "../types";

export class AfricaGameFragment extends MapGameFragment<AfricaDifficultyLevel> {

  protected getGame(): Game {
    return GAME_AFRICA;
  }

  protected allCountries(): Country[] {
    return AFRICA_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return AfricaMap;
  }

  protected getLevels(): AfricaDifficultyLevel[] {
    return AfricaDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case AfricaDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}